import React, { useState } from 'react';
import { Button } from '@mui/material';
import { sendOrionConfiguration } from '../../../services/emailService';
import EmailCardBuy from '../cards/EmailCardBuy';

/**
 * ReserveNow component renders a "Buy Now" button that opens an email form when clicked.
 * Users can input their email to reserve selected modules and their details, which are
 * sent to the backend. The form includes email submission and validation.
 * 
 * @component
 * @param {Object} props - The properties object.
 * @param {Array} props.selectedModules - Array of selected modules for reservation.
 * @param {number} props.price - Total price for the selected modules.
 * @param {string} props.deliveryTime - Estimated delivery time for the selected modules.
 */
const ReserveNow = ({ selectedModules, price, deliveryTime }) => {
  const [showEmailCard, setShowEmailCard] = useState(false);
  const [email, setEmail] = useState('');

  /**
   * Handles the display of the EmailCardBuy component when the "Buy Now" button is clicked.
   */
  const handleShowEmailCard = () => {
    setShowEmailCard(true);
  };

  /**
   * Closes the EmailCardBuy component.
   */
  const handleCloseCard = () => {
    setShowEmailCard(false);
  };

  /**
   * Handles the submission of the email and sends the selected modules, price, and delivery time to the backend.
   * Alerts the user upon success or failure.
   */
  const handleEmailSubmit = async () => {
    if (!email) {
      alert('Please enter your email.');
      return;
    }
    try {
      const response = await sendOrionConfiguration(email, selectedModules, price, deliveryTime);
      if (response.status === 'success') {
        alert('Orion configuration sent successfully!');
      } else {
        alert('Failed to send configuration.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Error sending configuration.');
    }
  };

  return (
    <div>
      <Button
        onClick={handleShowEmailCard}
        sx={{
          textTransform: 'none',
          margin: '10px',
          padding: '10px 50px',
          textAlign: 'center',
          transition: '0.5s',
          backgroundSize: '200% auto',
          color: 'white',
          borderRadius: '10px',
          display: 'block',
          border: '0px',
          fontWeight: 700,
          boxShadow: '0px 0px 14px -7px #2b8cb9',
          backgroundImage: 'linear-gradient(45deg, #064D6F 0%, #2b8cb9 51%, #1BB2F8 100%)',
          cursor: 'pointer',
          userSelect: 'none',
          '&:hover': {
            backgroundPosition: 'right center',
            color: '#fff',
            textDecoration: 'none'
          },
          '&:active': {
            transform: 'scale(0.95)'
          }
        }}
      >
        Buy Now
      </Button>

      {showEmailCard && (
        <EmailCardBuy
          email={email}
          setEmail={setEmail}
          onSubmit={handleEmailSubmit}
          onClose={handleCloseCard}
        />
      )}
    </div>
  );
};

export default ReserveNow;
